import { combineReducers } from 'redux';

import siteId from './siteId';
import openedFolder from './openedFolder';
import openedFile from './openedFile';
import sourceRevision from './sourceRevision';
import targetRevision from './targetRevision';
import isFileStructureShowing from './isFileStructureShowing';
import { fileFetchHasErrored, fileFetchIsLoading, fileStructure } from './fileStructure';
import { revisionFetchHasErrored, revisionFetchIsLoading, revision } from './revision';
import { xmlSourceFetchHasErrored, xmlSourceFetchIsLoading, xmlSourceFile } from './xmlSourceFile';
import { xmlTargetFetchHasErrored, xmlTargetFetchIsLoading, xmlTargetFile } from './xmlTargetFile';
import diffContextDisplay from './diffContextDisplay';

const rootReducer = combineReducers({
  siteId,
  fileFetchHasErrored,
  fileFetchIsLoading,
  fileStructure,
  revisionFetchHasErrored,
  revisionFetchIsLoading,
  revision,
  openedFolder,
  openedFile,
  sourceRevision,
  targetRevision,
  isFileStructureShowing,
  xmlSourceFetchHasErrored,
  xmlSourceFetchIsLoading,
  xmlSourceFile,
  xmlTargetFetchHasErrored,
  xmlTargetFetchIsLoading,
  xmlTargetFile,
  diffContextDisplay,
});

export default rootReducer;
